import { render, staticRenderFns } from "./EventServicesOrder.vue?vue&type=template&id=089a3a5c"
import script from "./EventServicesOrder.vue?vue&type=script&lang=js"
export * from "./EventServicesOrder.vue?vue&type=script&lang=js"
import style0 from "./EventServicesOrder.vue?vue&type=style&index=0&id=089a3a5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports